// extracted by mini-css-extract-plugin
export default {"Switch":"Switch_Switch__dF2wY","Switch-label":"Switch_Switch-label__QzpXQ"};